// src/config/index.js

const base_url = process.env.REACT_APP_GRAPHICS_API_URL || "";

const Config = {
  app: {
    max_msg_length: 100,
    media: {
      video: {
        controls: true,
        width: 320,
        height: 240,
        plugins: {
          record: {
            audio: true,
            video: true,
            maxLength: 10,
            debug: true
          }
        }
      },
      image: {
        controls: true,
        width: 320,
        height: 240,
        controlBar: {
          volumeMenuButton: false,
          fullscreenToggle: false
        },
        plugins: {
          record: {
            image: true,
            debug: true
          }
        }
      }
    }
  },
  base_url,
  api: {
    key: process.env.REACT_APP_API_KEY || '',
    base_url: base_url
  },
};

export default Config;